import { SkipBackIcon as PhosphorSkipBackIcon } from "@phosphor-icons/react/dist/ssr/SkipBack";

import { createAppIcon } from "@/components/createAppIcon";

export const SkipPreviousIcon = /* @__PURE__ */ createAppIcon(PhosphorSkipBackIcon);
